import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Contractor } from '@authority-labs/api-interfaces';
import { CrudDialogComponent } from '@check-list/app/classes/crud-dialog.component';
import { ContractorsService } from '../../../modules/contractors/contractors.service';

@Component({
  selector: 'authority-labs-contractor-dialog',
  templateUrl: './create-contractor-dialog.component.html',
  styleUrls: ['./create-contractor-dialog.component.scss']
})
export class CreateContractorDialogComponent extends CrudDialogComponent<Contractor> {
  get title(): string {
    return this.isNew ? 'יצירת קבלן חדש' : 'פרטי הקבלן';
  }
  constructor(
    public dialogRef: MatDialogRef<Contractor>,
    @Inject(MAT_DIALOG_DATA) contractor: Contractor,
    contractorsService: ContractorsService,
    injector: Injector
  ) {
    super(dialogRef, contractorsService, contractor, injector);
  }
}
